<template>
  <div class="border-b available flex justify-between pb-4 mb-6">
    <div class="available__action mt-8" >
      <span v-if="action === 'create'">
        <i v-show="level !== 1" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
      </span>
      <span v-else>
        <i v-if="isNewAvailableDay" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
        <span v-else>
          <span v-if="!loading">
            <i v-show="!isNewAvailableDay" @click="deleteAvailableDay" class="cursor-pointer el-icon-delete text-red-500 text-2xl"></i>
          </span>
          <vue-loaders v-else name="line-scale-pulse-out-rapid" color="red" scale="0.5"></vue-loaders>
        </span>
      </span>
    </div>
    <div class="available__select mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Day of Week
      </label>
      <el-select class="w-full" v-model="available_day_id" placeholder="Select Category">
        <el-option
          v-for="day in days"
          :key="day.value"
          :label="day.label"
          :value="day.value">
        </el-option>
      </el-select>
    </div>
    <div class="available__date-range mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Time Range
      </label>
      <el-time-picker
        class="w-full"
        is-range
        :value-format="'hh:mm:ss'"
        v-model="dateRange"
        range-separator="To"
        start-placeholder="Start time"
        end-placeholder="End time">
      </el-time-picker>
    </div>
    <div class="available__action mt-8">
      <i  v-show="count === level" @click="add()" class="el-icon-circle-plus-outline text-2xl"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailableTime',
  data() {
    return {
      loading: false,
    };
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      default: 'create',
    },
  },
  computed: {
    days() {
      return this.$store.getters['SettingsModule/Config/getAvailableDaysForSelect'];
    },

    key() {
      return this.level - 1;
    },

    available_day_id: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].available[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].available[this.key].available_day_id;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'available', key: this.key, property: 'available_day_id', payload: value,
        });
      },
    },

    dateRange: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].available[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].available[this.key].dateRange;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'available', key: this.key, property: 'dateRange', payload: value,
        });
      },
    },

    isNewAvailableDay() {
      const day = this.$store.state.InventoryModule.Products[this.action].available[this.key];
      if (day && Object.keys(day).length > 0) {
        return !day.id;
      }

      return true;
    },
  },

  methods: {
    remove() {
      this.$store.commit('InventoryModule/Products/removeProductMultipleData', {
        action: this.action, parent: 'available', key: this.key, index: this.level,
      });
    },

    add() {
      this.$store.commit('InventoryModule/Products/setActionMultipleProperty', {
        action: this.action, parent: 'available', payload: { [this.level]: {} },
      });
    },

    async deleteAvailableDay() {
      this.loading = true;
      const availableId = this.$store.state.InventoryModule.Products[this.action].available[this.key].id;
      try {
        await this.$store.dispatch('InventoryModule/Products/deleteItemAvailableDay', { availableId, productId: this.$route.params.id });
        await this.remove();
        this.$notify.success({
          title: 'Success',
          message: 'Available Day Successfully Deleted',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .available {
    .available__select {
      flex: 0 1 38%;
    }

    .available__date-range {
      flex: 0 1 52%;
    }

    .available__action {
      flex: 0 1 3%;
    }
  }

  .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 100% !important;
  }
</style>
